<template>
  <div>
    <div class="intro">
      <h2>Berichten van Bo</h2>
      <p class="light">Belangrijke updates en mededelingen die je niet wilt missen.</p>
    </div>
    <Spinner v-if="loading"/>
    <MessagesList
        v-else
        :messages="messages"
    />
  </div>
</template>

<script>

import {mapActions} from "vuex";
import MessagesList from "./messages/MessagesList.vue";
import Spinner from "../blocks/Spinner.vue";

export default {
  name: "Messages",
  data() {
    return {
      messages: [],
      loading: true,
    };
  },
  components: {
    MessagesList,
    Spinner
  },
  watch: {
    $route() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions("message", [
      "getMessages",
    ]),
    init() {
      this.getMessages().then(response => {
        this.messages = response;
        this.loading = false;
      });
    },
  },
};
</script>
